angular.module('bmsApp.merrymaids.job')
	.controller('MMCloseJobCtrl', [
		'$state',
		'$scope',
		'$stateParams',
		'$q',
		'$filter',
		'$ngBootbox',
		'notify',
		'TaxHelperSvc',
		'EmployeeOptionsSvc',
		'AccountingSvc',
		'MMJobPartSvc',
		'MMJobPartCancelReasonSvc',
		'MMDiscountSvc',
		'RecentPaymentSvc',
		function ($state,
				  $scope,
				  $stateParams,
				  $q,
				  $filter,
				  $ngBootbox,
				  notify,
				  TaxHelperSvc,
				  EmployeeOptionsSvc,
				  AccountingSvc,
				  MMJobPartSvc,
				  MMJobPartCancelReasonSvc,
				  MMDiscountSvc,
					RecentPaymentSvc) {

			var protos = {
				jobPartEmployee: function () {
					return {
						employee: null,
						duration_at_job: 0
					};
				}
			};

			function init() {
				$scope.MMJobMainCtrl.jobOrQuote = 'job';
				self.loading = true;
				var promises = [
					TaxHelperSvc.getVatRate()
						.then(function (vatRate) {
							self.vatRate = vatRate;
						}),
					EmployeeOptionsSvc.employee({filter: {status: 1}})
						.then(function (response) {
							self.form.options.employee = response.data.options;
						}),
					MMJobPartCancelReasonSvc.options()
						.then(function (response) {
							self.form.options.jobPartCancelReason = response.data.options;
						}),
					MMJobPartSvc.read(self.jobPartId)
						.then(function (response) {
							$scope.jobPart = self.jobPart = MMJobPartSvc.transformJobPart(response.data.job_part);
							// If job is now or in past
							let jobDate = moment($scope.jobPart.job_date);
							self.jobPartIsTodayOrInPast = jobDate.isBefore(moment().add(1, 'days').startOf('day'));
							self.jobPartOriginal = angular.copy(self.jobPart);
							if (self.jobPart.closed !== true) {
								if(self.jobPart.mm_job_part_cancel_reason_id){
									self.jobPart.completed = false;
								} else {
									// if not already closed, assume completed
									self.jobPart.completed = true;
								}
								if(self.jobPart.start_time){
									self.jobPart.start_time = moment(self.jobPart.start_time, 'HH:mm:ss');
								} else {
									if (self.jobPart.preferred_cleaning_time_type === 'Specific') {
										self.jobPart.start_time = moment(self.jobPart.preferred_cleaning_time, 'HH:mm:ss');
									}
									else if (self.jobPart.preferred_cleaning_time_type === 'AM' || self.jobPart.preferred_cleaning_time_type === 'Anytime Clean') {
										self.jobPart.start_time = moment('09:00:00', 'HH:mm:ss');
									}
									else if (self.jobPart.preferred_cleaning_time_type === 'PM') {
										self.jobPart.start_time = moment('12:00:00', 'HH:mm:ss');
									}
								}
							}

							// Employees
							if (self.jobPart.job_part_employees.length === 0 && self.jobPart.routes.length > 0 && !self.jobPart.closed) {
								angular.forEach(self.jobPart.routes[0].employees, (employee) => {
									let jobPartEmployee = {
										employee: employee,
										employee_id: employee.id,
									};
									self.jobPart.job_part_employees.push(jobPartEmployee);
									onJobPartEmployeeChange(jobPartEmployee);
								});
							}

							if(self.jobPart.end_time) {
								self.jobPart.end_time = moment(self.jobPart.end_time, 'HH:mm:ss');
							} else {
								if (moment.isMoment(self.jobPart.start_time) && !self.jobPart.closed) {
									fillJobPartEndTime();
								}
							}

							// Sidebar Data
							$scope.MMJobMainCtrl.jobPart = self.jobPart;
							// Additional Cost Schedule
							setAdditionalCostSchedule();
						})
				];
				$q.all(promises)
					.then(function () {
						self.loading = false;
					});
			}

			function getScheduledJobMinutes() {
				if (self.jobPart.custom_clean_duration) {
					return parseInt(self.jobPart.job_minutes);
				}
				else if (self.jobPart.job.job_minutes_first_in && parseInt(self.jobPart.clean_no) === 1) {
					return parseInt(self.jobPart.job.job_minutes_first_in);
				}
				else {
					return parseInt(self.jobPart.job.job_minutes);
				}
			}

			function valueIsUnchanged() {
				// parse all number comparison to floats, fall back to zero so not comparing NaN and undefined, etc.
				let jobPartGrossMatch = (parseFloat(self.jobPart.clean_gross) || 0) == (parseFloat(self.jobPartOriginal.clean_gross) || 0);
				let discountGrossMatch = (parseFloat(self.jobPart.discount_gross) || 0) == (parseFloat(self.jobPartOriginal.discount_gross) || 0);
				let additionalCostGrossMatch = (parseFloat((self.jobPart.additional_cost || {}).gross) || 0) == (parseFloat((self.jobPartOriginal.additional_cost || {}).gross) || 0);

				return jobPartGrossMatch && discountGrossMatch && additionalCostGrossMatch;
			}

			function valueIsChanged() {
				return !valueIsUnchanged();
			}

			function invoicePrototypeNet() {
				return getTotalNet();
			}

			function invoicePrototypeVat() {
				return getTotalVat();
			}

			function invoicePrototypeGross() {
				return getTotalGross();
			}

			function allocateCustomerPayment() {
				if (self.jobPart.preinvoice && self.jobPart.preinvoice.total_gross !== invoicePrototypeGross()) {
					self.jobPart.invoicePrototype = {}
				} else {
					self.jobPart.invoicePrototype = self.jobPart.preinvoice || {};
				}
				var amountPaid = self.jobPart.preinvoice ? self.jobPart.preinvoice.amount_paid : 0;
				angular.extend(self.jobPart.invoicePrototype, {
					invoice_number: 'This Invoice',
					invoice_date: self.jobPart.job_date,
					total_net: invoicePrototypeNet(),
					total_vat: invoicePrototypeVat(),
					total_gross: invoicePrototypeGross(),
					amount_paid: amountPaid,
					outstanding: invoicePrototypeGross() - amountPaid
				});
				AccountingSvc.showPaymentReceiptModal(self.jobPart.job.customer, self.jobPart.invoicePrototype)
					.then(function (modalResult) {
						self.jobPart.customer_payment = modalResult.customerPayment;
						validatePaymentAllocation();
					});
			}

			function removeCustomerPayment() {
				$ngBootbox.confirm('Are you sure you want to remove this customer payment?')
					.then(function () {
						delete self.jobPart.customer_payment;
						validatePaymentAllocation();
					});
			}

			function addEmployee() {
				var jobPartEmployee = protos.jobPartEmployee();
				self.jobPart.job_part_employees = self.jobPart.job_part_employees || [];
				self.jobPart.job_part_employees.push(jobPartEmployee);
				updateEmployeeJobDurationParts(jobPartEmployee);
			}

			function removeEmployee(jobPartEmployee) {
				jobPartEmployee.delete = true;
			}

			function fillJobPartEndTime() {
				let employeeCount = $filter('filter')(self.jobPart.job_part_employees, {
					'delete': '!true',
				}).length || 1;
				let jobDuration = getScheduledJobMinutes();
				let dividedJobDuration = Math.round(jobDuration / employeeCount);
				self.jobPart.end_time = self.jobPart.start_time.clone();
				self.jobPart.end_time.add(dividedJobDuration, 'minutes');
			}

			function fillEmployeeJobTime(jobPartEmployee) {
				// let selectedEmployees = getSelectedEmployees();
				// let employeeCount = selectedEmployees.length || 1;
				// let jobDuration = getScheduledJobMinutes();
				// jobPartEmployee.duration_at_job = Math.round(jobDuration / employeeCount);
				if (self.jobPart.start_time && self.jobPart.end_time) {
					jobPartEmployee.duration_at_job = self.jobPart.end_time.diff(self.jobPart.start_time, 'minutes');
				}
				else {
					jobPartEmployee.duration_at_job = 0;
				}
				updateEmployeeJobDurationParts(jobPartEmployee);
				checkTotalEmployeeDuration();
			}

			function updateEmployeeJobDurationParts(jobPartEmployee) {
				jobPartEmployee.duration_at_job_hours = Math.floor(jobPartEmployee.duration_at_job / 60) || 0;
				jobPartEmployee.duration_at_job_mins = jobPartEmployee.duration_at_job % 60 || 0;
			}

			function checkTotalEmployeeDuration() {
				let employeeDurationMinutes = 0;
				let selectedEmployees = getSelectedEmployees();
				angular.forEach(selectedEmployees, (jobPartEmployee) => {
					employeeDurationMinutes += jobPartEmployee.duration_at_job ? parseInt(jobPartEmployee.duration_at_job) : 0;
				});
				if (employeeDurationMinutes > getScheduledJobMinutes()) {
					// self.form.errors = [
					// 	'Employees have exceeded the expected job duration',
					// ];
				}
				else {
					self.form.errors = [];
				}
			}

			function getSelectedEmployees() {
				return $filter('filter')(self.jobPart.job_part_employees, {
					'delete': '!true',
				});
			}

			function calculateEmployeeMileage(jobPartEmployee) {
				if(!jobPartEmployee.miles_travelled){
					self.form.errors = ['Please enter valid value for miles travelled'];
					return;
				}
				self.form.processing = true;
				jobPartEmployee.calculatingMileage = true;
				MMJobPartSvc.calculateRouteEmployeeMileage(self.jobPart.id, jobPartEmployee.employee.id, jobPartEmployee.miles_travelled)
					.then(function (response) {
						jobPartEmployee.miles_travelled = response.data.miles_travelled;
						jobPartEmployee.mileage_value = response.data.mileage_value;
						jobPartEmployee.promptCalculateMileage = false;
						jobPartEmployee.isCalculatedMileage = true;
					}, function (errors) {
						self.form.errors = errors;
					})
					.finally(function () {
						jobPartEmployee.calculatingMileage = false;
						self.form.processing = false;
					});
			}

			function updateEmployeePaidAmount(jobPartEmployee) {
				if ($scope.isMMPayByPercentage() && !isNaN(jobPartEmployee.percentage_applied)) {
					var percentage = parseFloat(jobPartEmployee.percentage_applied);
					var totalNet = getTotalNet();
					jobPartEmployee.paid_amount = Math.round(totalNet * percentage) / 100;
				}
			}

			function updateAllEmployeePaidAmounts() {
				angular.forEach(self.jobPart.job_part_employees, function (jobPartEmployee) {
					updateEmployeePaidAmount(jobPartEmployee);
				});
			}

			function setAdditionalCostSchedule() {
				if (self.jobPart.additional_cost_schedule_due) {
					self.jobPart.additional_cost = {
						net: self.jobPart.job.additional_cost_schedule.net,
						description: 'Additional Cost Schedule',
					};
					self.handlers.onAdditionalCostNetChanged();
				}
			}

			function getTotalNet() {
				var jobPartNet = parseFloat(self.jobPart.clean_net) || 0;
				var discountNet = parseFloat(self.jobPart.discount_net) || 0;
				var additionalCostNet = angular.isObject(self.jobPart.additional_cost) ? (parseFloat(self.jobPart.additional_cost.net) || 0) : 0;

				return jobPartNet - discountNet + additionalCostNet;
			}

			function getTotalVat() {
				var jobPartVat = parseFloat(self.jobPart.clean_vat) || 0;
				var discountVat = parseFloat(self.jobPart.discount_vat) || 0;
				var additionalCostVat = angular.isObject(self.jobPart.additional_cost) ? (parseFloat(self.jobPart.additional_cost.vat) || 0) : 0;

				return jobPartVat - discountVat + additionalCostVat;
			}

			function getTotalGross() {
				var jobPartGross = parseFloat(self.jobPart.clean_gross) || 0;
				var discountGross = parseFloat(self.jobPart.discount_gross) || 0;
				var additionalCostGross = angular.isObject(self.jobPart.additional_cost) ? (parseFloat(self.jobPart.additional_cost.gross) || 0) : 0;

				return jobPartGross - discountGross + additionalCostGross;
			}

			function validatePaymentAllocation() {
				var retVal = true;
				if (angular.isObject(self.jobPart.customer_payment)) {
					var thisCustomerPaymentInvoice = $filter('filter')(self.jobPart.customer_payment.invoices, {id: '!true'})[0];

					retVal = parseFloat(thisCustomerPaymentInvoice.allocation) - getTotalGross() < 0.005;
				}
				self.invoicePaymentOverAllocated = !retVal;

				return retVal;
			}

			function validateCleanGross() {
				var retVal = true;
				if (parseFloat(parseFloat(self.jobPart.clean_gross) - self.jobPartOriginal.clean_gross) > 0.01) {
					retVal = false;
				}
				self.cleanGrossIncreased = !retVal;

				return retVal;
			}

			function calculateDiscount() {
				let deferred = $q.defer();

				self.form.calculatingDiscount = true;

				MMDiscountSvc.calculateDiscount({
					discount_type: self.jobPart.discount_type,
					discount_value: self.jobPart.discount_value,
					gross: self.jobPart.clean_gross,
					vat_rate: TaxHelperSvc.getRawVatRate(),
				})
					.then((response) => {
						angular.extend(self.jobPart, {
							discount_net: response.data.net_discount,
							discount_vat: response.data.vat_discount,
							discount_gross: response.data.gross_discount,
						});
					}).finally(() => {
						self.form.calculatingDiscount = false;
						deferred.resolve(true);
				});

				return deferred.promise;
			}


			function submit() {
				if (self.form.validator.api.valid() && validatePaymentAllocation() && validateCleanGross() && self.form.calculatingDiscount === false) {
					self.form.submitted = true;
					MMJobPartSvc.close(self.jobPart)
						.then(function (response) {
							notify({
								message: self.jobPart.closed ? 'Close job successfully updated' : 'Job successfully closed'
							});
							$state.go('main.merrymaids.job.close.list');
						}, function (errors) {
							self.form.errors = errors;
						})
						.finally(function () {
							self.form.submitted = false;
						});
				}
			}

			function onJobPartCleanNetChange() {
				var jobPart = self.jobPart;
				jobPart.clean_vat = TaxHelperSvc.vatFromNet(jobPart.clean_net);
				jobPart.clean_gross = TaxHelperSvc.grossFromNet(jobPart.clean_net);
				calculateDiscount()
					.then(() => {
						updateAllEmployeePaidAmounts();
						validatePaymentAllocation();
						validateCleanGross();
					});
			}

			function onJobPartCleanGrossChange() {
				var jobPart = self.jobPart;
				jobPart.clean_net = TaxHelperSvc.netFromGross(jobPart.clean_gross);
				jobPart.clean_vat = TaxHelperSvc.vatFromGross(jobPart.clean_gross);
				calculateDiscount()
					.then(() => {
						updateAllEmployeePaidAmounts();
						validatePaymentAllocation();
						validateCleanGross();
					});
			}

			function onAdditionalCostNetChanged() {
				var additionalCost = self.jobPart.additional_cost;
				additionalCost.vat = TaxHelperSvc.vatFromNet(additionalCost.net);
				additionalCost.gross = TaxHelperSvc.grossFromNet(additionalCost.net);
				updateAllEmployeePaidAmounts();
				validatePaymentAllocation();
			}

			function onAdditionalCostGrossChanged() {
				var additionalCost = self.jobPart.additional_cost;
				additionalCoFst.net = TaxHelperSvc.netFromGross(additionalCost.gross);
				additionalCost.vat = TaxHelperSvc.vatFromGross(additionalCost.gross);
				updateAllEmployeePaidAmounts();
				validatePaymentAllocation();
			}

			function onJobPartEmployeeChange(jobPartEmployee) {
				if (angular.isObject(jobPartEmployee.employee) && $scope.isMMPayByPercentage()) {
					angular.extend(jobPartEmployee, {
						percentage_applied: jobPartEmployee.employee.percentage,
					});
					onJobPartEmployeePercentageChange(jobPartEmployee);
				}
			}

			function onJobPartEmployeeDurationChange(jobPartEmployee) {
				jobPartEmployee.duration_at_job = (parseInt(jobPartEmployee.duration_at_job_hours) || 0) * 60;
				jobPartEmployee.duration_at_job += parseInt(jobPartEmployee.duration_at_job_mins) || 0;
				updateEmployeeJobDurationParts(jobPartEmployee);
				checkTotalEmployeeDuration();
			}

			function onJobPartEmployeePercentageChange(jobPartEmployee) {
				updateEmployeePaidAmount(jobPartEmployee);
			}

			function onJobPartEmployeePaidAmountChange(jobPartEmployee) {
				if ($scope.isMMPayByPercentage() && !isNaN(jobPartEmployee.paid_amount)) {
					var paidAmount = parseFloat(jobPartEmployee.paid_amount);
					var totalNet = getTotalNet();
					// job should always have a value greater than zero
					// percentage to 2dp
					jobPartEmployee.percentage_applied = Math.round(paidAmount / totalNet * 10000) / 100;
				}
			}

			function onJobPartEmployeeMilesTravelledChange(jobPartEmployee) {
				jobPartEmployee.promptCalculateMileage = true;
				jobPartEmployee.isCalculatedMileage = false;
			}

			function onJobPartEmployeeMileageValueChange(jobPartEmployee) {
				jobPartEmployee.promptCalculateMileage = true;
				jobPartEmployee.isCalculatedMileage = false;
			}

			function onSkipAdditionalCostScheduleChanged() {
				if (self.jobPart.skip_additional_cost_schedule) {
					self.jobPart.additional_cost = {};
				} else {
					setAdditionalCostSchedule();
				}
			}

			function recentPayments(){
				RecentPaymentSvc.showRecentPaymentModal(self.jobPart.job.customer);
			}

			var self = $scope.MMCloseJobCtrl = {
				jobPartId: $stateParams.jobPartId,
				loading: false,
				jobPart: undefined,
				jobPartOriginal: undefined,
				jobPartIsTodayOrInPast: false,
				methods: {
					init: init,
					valueIsUnchanged: valueIsUnchanged,
					valueIsChanged: valueIsChanged,
					allocateCustomerPayment: allocateCustomerPayment,
					removeCustomerPayment: removeCustomerPayment,
					addEmployee: addEmployee,
					removeEmployee: removeEmployee,
					fillJobPartEndTime: fillJobPartEndTime,
					fillEmployeeJobTime: fillEmployeeJobTime,
					calculateEmployeeMileage: calculateEmployeeMileage,
					submit: submit,
					recentPayments :recentPayments
				},
				handlers: {
					onSkipAdditionalCostScheduleChanged: onSkipAdditionalCostScheduleChanged,
					onJobPartCleanNetChange: onJobPartCleanNetChange,
					onJobPartCleanGrossChange: onJobPartCleanGrossChange,
					onAdditionalCostNetChanged: onAdditionalCostNetChanged,
					onAdditionalCostGrossChanged: onAdditionalCostGrossChanged,
					onJobPartEmployeeChange: onJobPartEmployeeChange,
					onJobPartEmployeeDurationChange: onJobPartEmployeeDurationChange,
					onJobPartEmployeePercentageChange: onJobPartEmployeePercentageChange,
					onJobPartEmployeePaidAmountChange: onJobPartEmployeePaidAmountChange,
					onJobPartEmployeeMilesTravelledChange: onJobPartEmployeeMilesTravelledChange,
					onJobPartEmployeeMileageValueChange: onJobPartEmployeeMileageValueChange
				},
				form: {
					processing: false,
					submitted: false,
					calculatingDiscount: false,
					options: {},
					validator: {
						config: {
							rules: {
								start_time: {
									timeBefore: '#end_time'
								},
								end_time: {
									timeAfter: '#start_time'
								}
							},
							messages: {
								start_time: {
									timeBefore: 'Start time must be before end time.'
								},
								end_time: {
									timeAfter: 'End time must be after start time.'
								}
							},
							errorPlacement: function (error) {
								error.appendTo('#form-errors');
							},
							errorContainer: '#form-errors'
						},
						api: {}
					}
				}
			}

		}
	]);
